var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F97316"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1172 12.4141L17.9688 13.5625C17.5586 13.9727 17.8594 14.6562 18.4336 14.6562H22.125C22.4805 14.6562 22.7812 14.3828 22.7812 14V10.3359C22.7812 9.76172 22.0703 9.46094 21.6602 9.87109L20.6758 10.8555C19.4453 9.70703 17.8047 8.96875 16 8.96875C12.6641 8.96875 9.90234 11.3477 9.32812 14.4922C9.27344 14.7109 9.4375 14.875 9.65625 14.875H11.2148C11.3516 14.875 11.4883 14.793 11.543 14.6289C12.0352 12.6328 13.8672 11.1836 15.9727 11.1562C17.1484 11.1562 18.2695 11.6211 19.1172 12.4141ZM9.875 16.8438C9.49219 16.8438 9.21875 17.1445 9.21875 17.5V21.1914C9.21875 21.7656 9.90234 22.0664 10.3125 21.6562L11.2969 20.6719C12.5273 21.8203 14.168 22.5312 16 22.5312C19.3086 22.5312 22.0703 20.1797 22.6445 17.0352C22.6992 16.8164 22.5352 16.6523 22.3164 16.6523H20.7578C20.6211 16.6523 20.4844 16.7344 20.4297 16.8984C19.9375 18.8945 18.1055 20.3438 16 20.3711C14.8242 20.3711 13.7031 19.9062 12.8555 19.1133L14.0039 17.9648C14.4141 17.5547 14.1133 16.8438 13.5391 16.8438H9.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshing);
export default __webpack_public_path__ + "static/media/refreshing.e58299bfa7af1976cf1336645e05eaac.svg";
export { ForwardRef as ReactComponent };